import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  diffInDays,
  getCurrentFYByDate,
  minutesToHHMM,
  secondsToHHMM,
  timeToSeconds,
} from "../../Utilitie";

const TWSCautionInsertion = ({ sec, stn }) => {
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const [globalDate, setGlobalDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  const op = ["UP", "DN"];

  const [entries, setEntries] = useState([
    {
      section_name: "",
      station: "",
      km: "",
      line: "",
      speed: "",
      reason: "",
      impose_date: "",
      impose_time: "",
      remarks: "",
      // block_given_date: "",
      // point_no: "",
      // cancel_date: "",
      // cancel_time: "",
      // impose_block_days: "",
      // impose_cancel_days: "",
    },
  ]);

  const keys = [
    "section_name",
    "station",
    "km",
    "line",
    "speed",
    "reason",
    "impose_date",
    "impose_time",
    "remarks",
    // "block_given_date",
    // "point_no",
    // "cancel_date",
    // "cancel_time",
    // "impose_block_days",
    // "impose_cancel_days",
  ];
  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        const updated = { ...row };

        if (key === "impose_time") {
          updated[key] = timeToSeconds(value);
        } else {
          updated[key] = value;
        }

        return updated;
      })
    );
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        section_name: "",
        station: "",
        km: "",
        line: "",
        speed: "",
        reason: "",
        impose_date: "",
        impose_time: "",
        remarks: "",
        // block_given_date: "",
        // point_no: "",
        // cancel_date: "",
        // cancel_time: "",
        // impose_block_days: "",
        // impose_cancel_days: "",
      },
    ]);
  };
  const removeRow = (index) =>
    setEntries((prev) => prev.filter((_, i) => i !== index));
  const handleClear = () => setEntries([]);

  const handleSubmit = async () => {
    const dataToSend = entries.map((entry) => ({
      ...entry,

      tws_date: globalDate,
    }));

    try {
      const response = await fetch(`${urlBlockPrefix}insertTWSCaution`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result?.message || "HTTP error");

      toast.success("✅ Data uploaded successfully!");
      setEntries([
        {
          section_name: "",
          station: "",
          km: "",
          line: "",
          speed: "",
          reason: "",
          impose_date: "",
          impose_time: "",
          remarks: "",

          // block_given_date: "",
          // point_no: "",
          // cancel_date: "",
          // cancel_time: "",
          // impose_block_days: "",
          // impose_cancel_days: "",
        },
      ]);
    } catch (error) {
      toast.error("❌ Failed to upload data");
    }
  };

  const handleDateChange = (value) => {
    setGlobalDate(value);
  };
  return (
    <div className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in TWS Caution
      </h5>

      <div className="d-flex justify-content-center align-items-center gap-3 m-3">
        <div>
          <label className="fw-bold me-2">Select Date:</label>
          <input
            type="date"
            className="form-control d-inline-block"
            style={{ width: "180px", fontSize: "0.9rem" }}
            value={globalDate}
            onChange={(e) => handleDateChange(e.target.value)}
          />
          <button className="btn btn-outline-primary m-2" onClick={addRow}>
            Add Row
          </button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              {keys.map((key, i) =>
                key === "impose_block_days" ||
                key === "impose_cancel_days" ? null : (
                  <th key={i}>{key.replace(/_/g, " ").toUpperCase()}</th>
                )
              )}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {entries.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, index) =>
                  key === "impose_block_days" ||
                  key === "impose_cancel_days" ? null : (
                    <td key={index}>
                      {key === "impose_date" ||
                      key === "block_given_date" ||
                      key === "cancel_date" ? (
                        <input
                          type="date"
                          className="form-control"
                          style={{ width: "140px", fontSize: "0.8rem" }}
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "impose_time" || key === "cancel_time" ? (
                        <input
                          type="time"
                          className="form-control"
                          style={{ width: "140px", fontSize: "0.8rem" }}
                          value={row[key] ? secondsToHHMM(row[key]) : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "section_name" ||
                        key === "line" ||
                        key === "station" ? (
                        <select
                          className="form-control"
                          style={{ width: "100px", fontSize: "0.8rem" }}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        >
                          <option value="" hidden>
                            Select
                          </option>
                          {sec.map(
                            (item, i) =>
                              key === "section_name" && (
                                <option key={i} value={item}>
                                  {item}
                                </option>
                              )
                          )}{" "}
                          {stn.map(
                            (item, i) =>
                              key === "station" && (
                                <option key={i} value={item}>
                                  {item}
                                </option>
                              )
                          )}
                          {op.map(
                            (item, i) =>
                              key === "line" && (
                                <option key={i} value={item}>
                                  {item}
                                </option>
                              )
                          )}
                        </select>
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "100px", fontSize: "0.8rem" }}
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  )
                )}

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeRow(rowIndex)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-outline-danger m-2" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-outline-success m-2" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default TWSCautionInsertion;
